import { StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
export const updateQuery = createAction('commerce/query/update', (payload) => validatePayload(payload, {
    query: new StringValue(),
}));
